// slices/signUpSlice.js
import { createSlice } from "@reduxjs/toolkit"

const initialState = {}

const signUpSlice = createSlice({
  name: "signUp",
  initialState,
  reducers: {
    setSignUpData(state, action) {
      // Mutate state directly instead of returning a new object
      Object.assign(state, action.payload)
    },
    resetSignUp(state) {
      // Clear all keys in state
      Object.keys(state).forEach(key => delete state[key])
    }
  }
})

export const { setSignUpData, resetSignUp } = signUpSlice.actions

export default signUpSlice.reducer
